/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const fields_array = [];

const toggleAddButton = function() {
  if (($("#new_project_participant").length > 0) && $("#new_project_participant").parsley().isValid()) {
    return $("#add_participant_submit_button").removeAttr('disabled');
  } else {
    return $("#add_participant_submit_button").removeClass('processing').attr('disabled', true);
  }
};

$(document).on('change', '#project_participant_proof', function() {
  toggleAddButton();
  $('.filename#request_participation_file').html($("input[type='file'][id$='project_participant_proof']")[0].files[0].name);
  $('#remove_proof').removeClass('hide');
  return $('#remove_proof').addClass('show');
});

$(document).on('click', '#remove_participation_proof', function() {
  $("#project_participant_proof").val("");
  $('.filename#request_participation_file').html("");
  $('#remove_proof').removeClass('show');
  return $('#remove_proof').addClass('hide');
});

$(document).on('change', '#more_info', function() {
  if (this.checked) {
    $('#participant_more_info').removeClass('hide');
    return $('#participant_more_info').addClass('show');
  } else {
    $('#participant_more_info').removeClass('show');
    return $('#participant_more_info').addClass('hide');
  }
});

$(function() {
  root.ProjectParticipantsLink = class ProjectParticipantsLink {
    constructor() {
      $(document).on("click", "a#add_participants",function(e) {
        $("#edit_participants_form").slideToggle();
        toggleAddButton();
        // $("#project_participant_role").focus()
        if ($('.project_participation_requested').length === 0) {
          $("#project_participant_company_name").val("");
        }
        new root.ProjectParticipantsFormManager;
        return e.preventDefault();
      });

      $(document).on("select2-close", $("#project_participant_company_name"), function(e) {
        if ($("#project_participant_company_name").select2('val').length === 0) {
          $("#no_company_by_that_name").hide();
          return toggleAddButton();
        }
      });

      $(document).on("keyup", $("#project_participant_email"), e => toggleAddButton());
    }
  };

  new root.ProjectParticipantsLink;

  root.ProjectParticipantsFormManager = class ProjectParticipantsFormManager {
    constructor() {
      this.enableValidation = this.enableValidation.bind(this);
      this.enableAutocompletion = this.enableAutocompletion.bind(this);
      this.enableAfterSubmit = this.enableAfterSubmit.bind(this);
      this.enableAfterRequest = this.enableAfterRequest.bind(this);
      this.validateAsExistingCompany = this.validateAsExistingCompany.bind(this);
      this.validateAsNewCompany = this.validateAsNewCompany.bind(this);
      this.form             = $("#new_project_participant");
      this.activities_group = $("#business_activities_group");
      this.activities       = $("#project_participant_business_activities");
      this.company_name     = $("#project_participant_company_name");
      this.company_id       = $("#project_participant_company_id");
      this.email            = $("#project_participant_email");
      this.no_company       = $("#no_company_by_that_name");
      this.add_button       = $("#add_participant_submit_button");

      this.enableValidation();
      this.enableAutocompletion();
      this.enableAfterSubmit();
      this.enableAfterRequest(); // request sent from project_participants_controller
    }

    enableValidation() {
      return this.form.parsley();
    }

    enableAutocompletion() {
      $(this.company_name).select2({
        multiple: true,
        separator: "|",
        placeholder: "Enter company name...",
        width: "100%",
        quietMillis: 100,
        minimumInputLength: 3,
        maximumSelectionSize: 1,
        formatResult(data) {
          return `<div class=company-thumb><img src=${data.image}></img></div><div class=name-address-container><div class=company-name>${data.text}</div><div class=company-address> ${data.address || ' '} </div></div>`;
        },
        ajax: {
          url: "/companies/" + $(this.company_name).data("name") + "/auto_complete_search",
          dataType: "json",
          data(term, page) {
            return {
              q: term,
              page_limit: 10,
              page,
              project_id: $('#project_id').val()
            };
          },
          results: (data, page) => {
            const more = (page * 10) < data.pop();
            return {results: data};
          }
        },
        createSearchChoice: (term, data) => {
          if ($(data).filter(function() {
            return this.text.localeCompare(term) === 0;
          }).length === 0) {
            $(this.no_company).show();
            const choice = {
              id: term,
              text: term
            };
            return choice;
          } else {
            return $(this.no_company).hide();
          }
        }
      }).on("change", event => {
        toggleAddButton();
        $('.project_participant_company_name').find(".select2-search-field input").val('');
        if ((parseInt(event.val) + "") === event.val) { // company has an ID and exists
          this.no_company.hide();
          $(this.company_id).val(event.val);
          return this.validateAsExistingCompany();
        } else {
          if ($(this.company_name).select2('val').length !== 0) {
            this.no_company.show();
            this.validateAsNewCompany();
          } else {
            $("#no_company_by_that_name").hide();
          }

          if (event.added === undefined) {
            $(this.no_company).show();
            return this.validateAsNewCompany();
          } else {
            $(this.company_id).val(event.val);
            $(this.no_company).hide();
            this.validateAsExistingCompany();
            return $(this.company_name)
              .closest("div.project_participant_company_name")
              .find(".select2-search-choice div").html($(this.company_name).closest("div.project_participant_company_name").find(".select2-search-choice div").html().replace(/&lt;em&gt;|&lt;\/em&gt;|<em>|<\/em>/g, ""));
          }
        }
      });


      return $(this.activities).select2({
        width: "resolve",
        placeholder: $(this.activities).attr("placeholder")
      }).on("change", event => {
        toggleAddButton();
        return $('.project_participant_business_activities').find('.select2-search-field input').val('');
      });
    }

    enableAfterSubmit() {
      return this.form.on("after_submit", () => {
        $('#edit_participants_form').toggle(false);
        this.no_company.hide();
        this.company_id.val('');
        this.company_name.val('');
        this.email.val('');
        return this.activities.select2('val', '');
      });
    }

    enableAfterRequest() {
      $(window).on("project_participant:add:success", () => {
        $('.pp-verification').hide();
        $('#success-confirmation-form').show();
        $('#signup_name').focus();
        $('#add_participants.hide').removeClass('hide');
        return $('#add_your_participation').remove();
      });

      $(window).on("project_participant:add:failure", () => {
        $('.pp-verification').hide();
        return $('#error-confirmation-form').show();
      });

      $(window).on("project_participant:verified", () => {
        return $('#confirmation-denied').hide();
      });

      return $(window).on("project_participant:denied", () => {
        $('#confirmation-verified').hide();
        return $('#post-verification-signup').hide();
      });
    }

    validateAsExistingCompany() {
      this.email.removeAttr('required');
      return this.email.attr('data-parsley-required', 'false');
    }

    validateAsNewCompany() {
      return this.email.attr('required', true);
    }
  };

  if ($("#new_project_participant").length) { return new root.ProjectParticipantsFormManager; }
});
